import {Box, Grid, Typography} from "@material-ui/core";
import {DataGrid} from "@material-ui/data-grid";
import {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {makeStyles} from "@material-ui/core/styles";
import UniDialog from "../Common/UniDialog";
import _ from "lodash";
const useStyles = makeStyles((theme) => ({
    margin: {
        margin: theme.spacing(1),
    },
    group: {
        display: 'flex',
        alignItems: 'center'
    },
    item: {
        color: 'white'
    },
    excelMargin: {
        margin: theme.spacing(1)
    },
    formControl: {
        marginBottom: theme.spacing(1),
        minWidth: 220,

    }, leftSection: {
        paddingTop: theme.spacing(3),

        display: 'flex',
        justifyContent: 'space-evenly',
        alignItems: 'left',

    },
}));

function DriverDetailDialog(props) {
    const {t} = useTranslation('driverEfficiencyMonitor');
    const classes = useStyles();
    const PAGE_SIZE = 20;
    const [openDetailsDialog, setOpenDetailsDialog] = useState(false);

    useEffect(() => {
        if (!_.isEmpty(props.driverInfo) && props.detailType === 'driver_info') {
            setOpenDetailsDialog(true);
        }
    }, [props.driverInfo])

    return (
        <UniDialog
            title={t(props.detailType)}
            open={openDetailsDialog}
            onClose={() => {
                setOpenDetailsDialog(false)
                props.handleDetailClosed();
            }}
            maxWidth='xs'
            fullWidth
            disableDefaultButtons
        >
            {props.detailType === "driver_info" &&
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Typography variant='body2'>
                            <span className={classes.labelTitle}>{t('driver_id')}: </span>
                            {props.driverInfo && props.driverInfo?.driver_id || "N/A"}
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography variant='body2'>
                            <span className={classes.labelTitle}>{t('full_name')}: </span>
                            {props.driverInfo?.basis?.first_name} {props.driverInfo?.basis?.last_name}
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography variant='body2'>
                            <span className={classes.labelTitle}>{t('phone_number')}: </span>
                            {props.driverInfo?.basis && props.driverInfo?.basis?.phone || "N/A"}
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography variant='body2'>
                            <span className={classes.labelTitle}>{t('plate_num')}: </span>
                            {props.driverInfo?.driver && props.driverInfo?.driver?.vehicle_plate || "N/A"}
                        </Typography>
                    </Grid>
                </Grid>
            }
        </UniDialog>
    )
}

export default DriverDetailDialog;